import { render, staticRenderFns } from "./KitMultipleCreate.vue?vue&type=template&id=44510514"
import script from "./KitMultipleCreate.vue?vue&type=script&lang=js"
export * from "./KitMultipleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports